import styled from 'styled-components';

export default styled.div`


  ${ props => props.selfContain ? `
    position: absolute;
    top: -1.7rem;
  ` : ''}
`;
